module.exports = __webpack_public_path__ + "static/img/product15.35894b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product15.png
// module id = YX2P
// module chunks = 1